module.exports = __webpack_public_path__ + "static/media/iconSepultacionStar.b7240c90.svg";